<template>
  <v-card>
    <v-toolbar v-if="isMobile" color="grey-lighten-1 flex-grow-0" :class="$style.toolbar">
      <v-toolbar-title>{{ $t('basket.title') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon :title="$t('general.close')" @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text
      class="pa-4"
      :class="{ [$style.productList]: true, [$style['productList--menu']]: !isMobile }"
    >
      <v-skeleton-loader
        v-if="!count && (pending || basketInitial)"
        width="100%"
        type="image"
      ></v-skeleton-loader>
      <div v-show="count > 0">
        <div v-for="client in clients" :key="client">
          <h3 :class="$style.brand"><BrandLogoRef :client="client" :class="$style.brandLogo" /></h3>
          <BasketProductGrouped
            v-for="product in clientProducts[client].basketBikesGrouped"
            :key="product.id"
            v-bind="{ ...product, currency, selfBasketUrl }"
            :class="$style['basket-product']"
            :mini-basket="true"
            :is-mobile="isMobile"
            @openBasketForm="openBasketForm"
            @dataFetchPending="setDataFetchPending"
            @close="$emit('close')"
          />
          <BasketProductGrouped
            v-for="product in clientProducts[client].basketSparepartsGrouped"
            :key="product.id"
            v-bind="{ ...product, currency, selfBasketUrl }"
            :class="$style['basket-product']"
            :mini-basket="true"
            :is-mobile="isMobile"
            @openBasketForm="openBasketForm"
            @dataFetchPending="setDataFetchPending"
            @close="$emit('close')"
          />
        </div>
      </div>
      <BasketEmpty v-show="!basketInitial && !count && !pending" />
      <BasketMessages />
      <v-overlay v-if="pending" absolute :value="pending">
        <v-progress-circular :size="64" :indeterminate="pending" />
      </v-overlay>
    </v-card-text>
    <v-card-actions class="flex-column align-stretch pa-0">
      <MiniBasketTotal :amount="count" :price="price" :currency="currency" :pending="pending" />
      <MiniBasketButtons :pending="pending" :show-close="!isMobile" @close="$emit('close')" />
    </v-card-actions>
    <v-dialog
      v-model="basketFormDialogOpen"
      transition="dialog-transition"
      persistent
      :fullscreen="isMobile"
      scrollable
      max-width="1200px"
      @keydown.esc="closeBasketForm"
    >
      <ProductBasketForm v-bind="basketFormData" @close="closeBasketForm" />
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'

import aimeosGetters from '@/js/plugins/store/modules/aimeos/getter-types'
import { REQUEST_STATE } from '@/js/plugins/store/modules/aimeos/constants'

import BasketEmpty from '@/js/components/Basket/BasketEmpty.vue'
import BasketMessages from '@/js/components/Basket/BasketMessages.vue'
import MiniBasketTotal from '@/js/components/Basket/Mini/MiniBasketTotal.vue'
// import BasketProduct from '@/js/components/Basket/BasketProduct.vue'
import BasketProductGrouped from '@/js/components/Basket/BasketProductGrouped.vue'
import MiniBasketButtons from '@/js/components/Basket/Mini/MiniBasketButtons.vue'
import ProductBasketForm from '@/js/components/ProductDetail/ProductBasketForm.vue'
import BrandLogoRef from '@/js/components/Shared/BrandLogoRef.vue'

export default {
  name: 'MiniBasketContent',
  components: {
    BasketEmpty,
    MiniBasketTotal,
    // BasketProduct,
    BasketProductGrouped,
    MiniBasketButtons,
    ProductBasketForm,
    BrandLogoRef,
    BasketMessages,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataFetchPending: false,
      basketFormData: {},
      basketFormDialogOpen: false,
    }
  },
  computed: {
    ...mapGetters(STOREMODULES.AIMEOS, {
      clientProducts: aimeosGetters.BASKET_CLIENT_PRODUCTS_GROUPED,
      clients: aimeosGetters.BASKET_CLIENTS,
      count: aimeosGetters.BASKET_COUNT,
      price: aimeosGetters.BASKET_PRICE,
      currency: aimeosGetters.BASKET_CURRENCYID,
      basketPending: `BASKET_${REQUEST_STATE.STATE_PENDING}`,
      basketInitial: `BASKET_${REQUEST_STATE.STATE_INITIAL}`,
      selfBasketUrl: aimeosGetters.BASKET_BASKET_PRODUCT_POST_URL,
    }),
    pending() {
      return this.basketPending || this.dataFetchPending
    },
  },
  methods: {
    openBasketForm(basketFormData) {
      // console.log(basketFormData)
      this.basketFormData = { ...basketFormData }
      this.basketFormDialogOpen = true
    },
    closeBasketForm() {
      this.basketFormDialogOpen = false
      this.basketFormData = {}
    },
    setDataFetchPending(state) {
      // small delay for off state.. to wait for start of basket request
      if (!state) {
        setTimeout(() => {
          this.dataFetchPending = state
        }, 250)
      } else {
        this.dataFetchPending = state
      }
    },
  },
}
</script>

<style lang="scss" module>
.toolbar {
  z-index: 1;
}

.productList {
  position: relative;
}

.productList--menu {
  max-height: calc(100vh - 20rem);
  overflow: auto;
}

// .basket-products--menu {
//   @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
//     max-height: calc(100vh - 20rem);
//   }
//   max-height: calc(100vh - 11rem);
//   overflow:  auto;
// }

.basket-product {
  margin-bottom: -1px;

  &:last-child {
    margin-bottom: 0;
  }
}

.brand {
  padding: 0.25rem 1.5rem;

  color: var(--white);

  text-align: center;

  background: var(--black);

  &.brand {
    // @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    //   font-size: 1.25rem;
    // }

    margin-bottom: 0;

    // font-size: 1rem;
  }
}

.brandLogo {
  min-width: 4rem;
  height: 1rem;
}
</style>
